module.exports = __webpack_public_path__ + "img/hometopone.7f6e19fe.jpg";